import React, { useRef, useState, useEffect } from "react";
import {buttons, fontSizes, rounded, spacing } from "../styles/tokens";

export default function TapBPM({ bpm, onBPMChange }) {
  const [localBPM, setLocalBPM] = useState(bpm || 0);
  const tapsRef = useRef([]);
  const timeoutRef = useRef(null);

  useEffect(() => {
    setLocalBPM(bpm || 0);
  }, [bpm]);

  const handleTap = () => {
    const now = Date.now();
    tapsRef.current.push(now);

    if (tapsRef.current.length > 3) {
      tapsRef.current.shift(); // keep last 3
    }

    if (tapsRef.current.length >= 2) {
      const intervals = tapsRef.current
        .slice(1)
        .map((t, i) => t - tapsRef.current[i]);
      const avgInterval =
        intervals.reduce((a, b) => a + b, 0) / intervals.length;
      const newBPM = Math.round(60000 / avgInterval);
      setLocalBPM(newBPM);
      onBPMChange(newBPM);
    }

    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      tapsRef.current = [];
    }, 2000);
  };

  const handleManualChange = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) {
      setLocalBPM(val);
      onBPMChange(val);
    }
  };

  const increment = () => {
    const newVal = localBPM + 1;
    setLocalBPM(newVal);
    onBPMChange(newVal);
  };

  const decrement = () => {
    const newVal = Math.max(1, localBPM - 1);
    setLocalBPM(newVal);
    onBPMChange(newVal);
  };

  return (
    <div className={`flex items-center flex-wrap ${spacing.gapSm}`}>
      <button
        onClick={handleTap}
        className={buttons.activePurpleSm}
      >
        Tap
      </button>

      <div className={`flex items-center ${spacing.gapSm}`}>
        <button
          type="button"
          onClick={decrement}
          className={`${fontSizes.sm} px-2 py-1 bg-white border ${rounded.md} hover:bg-gray-100`}
        >
          −
        </button>
        <input
          type="number"
          min="1"
          value={localBPM}
          onChange={handleManualChange}
          className={`w-12 ${fontSizes.sm} text-center p-1 border ${rounded.md} shadow-inner`}
          placeholder="BPM"
        />
        <button
          type="button"
          onClick={increment}
          className={`${fontSizes.sm} px-2 py-1 bg-white border ${rounded.md} hover:bg-gray-100`}
        >
          +
        </button>
      </div>
    </div>
  );
}
